import ReactDOM from 'react-dom';
import preloaded from '../../src/preloaded';

import NukaCarousel from '../../src/nukaCarousel/NukaCarousel.jsx';

// Get Video Carousels container and create NukaCarousel
let domVideoContainer = document.querySelector('.video-carousel');
if (domVideoContainer) {
  ReactDOM.render(<NukaCarousel media={preloaded.recent_videos} team_title={preloaded.team_title} type='videos' />, domVideoContainer);
}